import { useState } from 'react';

interface ContactAvatarProps {
  type: 'person' | 'company';
  name?: string;
  firstName?: string;
  lastName?: string;
  logo?: string | null;
  size?: number;
}

const COLORS = [
  '#3B82F6', '#10B981', '#F59E0B', '#EF4444',
  '#8B5CF6', '#EC4899', '#06B6D4', '#84CC16',
];

function computeLabel(p: ContactAvatarProps): string {
  if (p.type === 'company') return p.name ?? '';
  return `${p.firstName ?? ''} ${p.lastName ?? ''}`.trim();
}

function getInitials(label: string): string {
  const words = label.split(' ').filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

function hasValidLogo(logo?: string | null): logo is string {
  return typeof logo === 'string' && logo.trim() !== '' && logo !== 'null';
}

export default function ContactAvatar(props: ContactAvatarProps) {
  const { logo, size = 40 } = props;
  const [imgFailed, setImgFailed] = useState(false);

  const showImage = hasValidLogo(logo) && !imgFailed;

  if (showImage) {
    return (
      <img
        src={logo as string}
        alt=""
        width={size}
        height={size}
        style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover' }}
        onError={() => setImgFailed(true)}
      />
    );
  }

  const initials = getInitials(computeLabel(props));
  const color = COLORS[initials.charCodeAt(0) % COLORS.length];

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        color: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: size * 0.4,
        lineHeight: 1,
        userSelect: 'none',
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  );
}
